import React, { useState } from "react";
import { useNavigate } from "react-router";
import { Plus, Search } from "lucide-react";
import { Container } from "@material-ui/core";
import PageTitle from "../../components/pageTitle/PageTitle";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Input } from "../../components/ui/input";

const InvoiceManage = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [dateFilter, setDateFilter] = useState("last-12-months");

  return (
    <Container>
      <PageTitle
        pageTitle="Invoices Manage"
        showBreadcrumb={[{ label: "Home", to: "/" }, { label: "Operations" }]}
        BreadCrumbCurrentPageTitle={"Invoices"}
        // showLastSeen={true}
        buttonTitle="Create Invoice"
        icons={<Plus className="h-4 w-4 mr-5" />}
        buttonClass={"d-flex flex-center"}
        buttonStyle={{
          color: "white",
          backgroundColor: "#16A34A",
          padding: "8px 16px",
          borderRadius: "5px",
        }}
        buttonClick={() => navigate("/invoices/create")}
      />
      <div className="space-y-6 ph-32 pv-24">
        {/* Header with Create Invoice Button */}
        <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-foreground">
              Invoices
            </h1>
          </div>
        </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-card p-24 rounded-lg shadow-sm border border-border">
          <div className="flex justify-between items-start mb-16">
            <div>
              <div className="text-lg font-semibold text-muted-foreground">$15,034.69 Unpaid (last 365 days)</div>
            </div>
          </div>
          
          <div className="space-y-4">
            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <div className="text-2xl font-bold text-card-foreground">$9,336.19</div>
                <div className="text-sm text-muted-foreground">Overdue</div>
              </div>
              <div className="w-full bg-secondary/20 rounded-full h-2">
                <div 
                  className="bg-orange-500 h-2 rounded-full transition-all duration-700 ease-out" 
                  style={{ 
                    width:'60%' 
                  }}
                />
              </div>
            </div>

            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <div className="text-2xl font-bold text-card-foreground">$5,698.50</div>
                <div className="text-sm text-muted-foreground">Not due yet</div>
              </div>
              <div className="w-full bg-secondary/20 rounded-full h-2">
                <div 
                  className="bg-blue-500 h-2 rounded-full transition-all duration-700 ease-out" 
                  style={{ 
                    width: '40%' 
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="bg-card p-24 rounded-lg shadow-sm border border-border">
          <div className="flex justify-between items-start mb-16">
            <div>
              <div className="text-lg font-semibold text-muted-foreground">$25,123.34 Paid (last 30 days)</div>
            </div>
          </div>
          
          <div className="space-y-4">
            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <div className="text-2xl font-bold text-card-foreground">$0.00</div>
                <div className="text-sm text-muted-foreground">Not deposited</div>
              </div>
              <div className="w-full bg-secondary/20 rounded-full h-2">
                <div 
                  className="bg-yellow-500 h-2 rounded-full transition-all duration-700 ease-out" 
                  style={{ 
                    width: '0%' 
                  }}
                />
              </div>
            </div>

            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <div className="text-2xl font-bold text-card-foreground">$25,123.34</div>
                <div className="text-sm text-muted-foreground">Deposited</div>
              </div>
              <div className="w-full bg-secondary/20 rounded-full h-2">
                <div 
                  className="bg-green-500 h-2 rounded-full transition-all duration-700 ease-out" 
                  style={{ 
                    width: '100%' 
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
        <div className="flex flex-col lg:flex-row gap-4 items-start lg:items-center justify-between">
        <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
          <Select value={statusFilter} onValueChange={setStatusFilter}>
            <SelectTrigger className="w-full sm:w-32">
              <SelectValue placeholder="Status" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All</SelectItem>
              <SelectItem value="paid">Paid</SelectItem>
              <SelectItem value="pending">Pending</SelectItem>
              <SelectItem value="sent">Sent</SelectItem>
              <SelectItem value="overdue">Overdue</SelectItem>
              <SelectItem value="draft">Draft</SelectItem>
            </SelectContent>
          </Select>
          
          <Select value={dateFilter} onValueChange={setDateFilter}>
            <SelectTrigger className="w-full sm:w-40">
              <SelectValue placeholder="Date range" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="last-12-months">Last 12 months</SelectItem>
              <SelectItem value="last-30-days">Last 30 days</SelectItem>
              <SelectItem value="last-90-days">Last 90 days</SelectItem>
              <SelectItem value="this-year">This year</SelectItem>
            </SelectContent>
          </Select>
        </div>
        
        <div className="relative w-full lg:w-80">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" size={18} />
          <Input
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search invoices..."
            className="pl-40"
          />
        </div>
      </div>
      </div>
    </Container>
  );
};

export default InvoiceManage;
